module.exports = "<div class=\"d-print-none\">\n    <hr class=\"hr--thin_dotted\"/>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/pageSeparator.html
// module id = 789
// module chunks = 0